export default (function (value) {
  return value === null;
});